<ul>
  @for (tab of tabs; track trackItem($index, tab)) {
    <li class="inline-block" [ngClass]="{'is-selected': tab.tabSelected}">
      <a href="#" (click)="selectTab(tab, $event)" class="tab__label black"><span class="normal">{{tab.tabTitle}}</span><span
          id="{{tab.tabId}}">{{tab.selectedCount}}</span></a>
    </li>
  }
</ul>
<ng-content></ng-content>